/**
 * SQL Query Schemas
 *
 * Zod schemas for SQL query execution API.
 * Supports read-only mode (SELECT only) and danger mode (all queries).
 */

import { z } from "zod";

/**
 * Request body for executing SQL queries
 */
export const ExecuteSqlBodySchema = z.object({
  /**
   * The SQL query to execute
   * Max 10000 characters to prevent overly large queries
   */
  query: z.string().min(1, "Query is required").max(10000, "Query too long"),

  /**
   * Whether danger mode is enabled
   * When false, only SELECT queries are allowed
   * When true, all queries (INSERT, UPDATE, DELETE, etc.) are allowed
   */
  dangerMode: z.boolean().default(false)
});

/**
 * Field metadata from query result
 */
export const SqlResultFieldSchema = z.object({
  /** Column name */
  name: z.string(),
  /** PostgreSQL data type OID */
  dataTypeID: z.number()
});

/**
 * Response from SQL query execution
 */
export const ExecuteSqlResponseSchema = z.object({
  /** Query result rows (empty if error) */
  rows: z.array(z.record(z.string(), z.unknown())),
  /** Number of rows affected or returned (0 if error) */
  rowCount: z.number(),
  /** Column metadata (empty if error) */
  fields: z.array(SqlResultFieldSchema),
  /** Query execution time in milliseconds */
  executionTimeMs: z.number(),
  /** Raw error message if query failed */
  error: z.string().optional()
});
